import * as tslib_1 from "tslib";
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { lazyAddCanNotShareLinkId, lazySetLinkFileName, lazyUpdateInfoBar, } from 'owa-attachment-well-data';
export default function handleGetSharingInfoResponse(linkId, viewState, parentItemIdWrapper, response, infoBarAddHandler, infoBarRemoveHandler) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var setLinkFileName, updateInfoBar;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(response &&
                        response.FileName &&
                        response.FileName.length > 0 &&
                        !response.CanShareInternally)) return [3 /*break*/, 4];
                    // Save the link Ids and trigger updating sharing tips in info bar.
                    logUsage(datapoints.AttachmentComposeSPLinksCanNotShareInternally.datapoint.name);
                    return [4 /*yield*/, lazySetLinkFileName.import()];
                case 1:
                    setLinkFileName = _a.sent();
                    setLinkFileName(linkId, response.FileName);
                    return [4 /*yield*/, lazyAddCanNotShareLinkId.importAndExecute(viewState, linkId)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, lazyUpdateInfoBar.import()];
                case 3:
                    updateInfoBar = _a.sent();
                    updateInfoBar(viewState, parentItemIdWrapper.itemId, infoBarAddHandler, infoBarRemoveHandler);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=handleGetSharingInfoResponse.js.map